import { render, staticRenderFns } from "./ProductSegmentBuilder.vue?vue&type=template&id=66272284&scoped=true"
import script from "./ProductSegmentBuilder.vue?vue&type=script&lang=ts"
export * from "./ProductSegmentBuilder.vue?vue&type=script&lang=ts"
import style0 from "./ProductSegmentBuilder.vue?vue&type=style&index=0&id=66272284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66272284",
  null
  
)

export default component.exports